import apiClient from './client'
import type { GameSession, CurrentSetSummary } from '../types/session.types'

interface PageResponse<T> {
    content: T[]
    totalElements: number
    totalPages: number
    size: number
    number: number
}

export const fetchActiveSession = async (tableId: number): Promise<GameSession> => {
    const response = await apiClient.get(`/tables/${tableId}/session`)
    return response.data.data
}

export const fetchCurrentUserActiveSessions = async (): Promise<GameSession[]> => {
    const response = await apiClient.get('/users/me/active-sessions')
    return response.data.data
}

export const getCurrentSetSummary = async (
    tableId: number,
    options?: { forClosing?: boolean }
): Promise<CurrentSetSummary> => {
    const params = options?.forClosing ? { forClosing: true } : undefined
    const response = await apiClient.get(`/tables/${tableId}/session/set-summary`, { params })
    return response.data.data
}

export const fetchSessionHistory = async ({
                                              page = 0,
                                              size = 20,
                                              tableId
                                          }: {
    page?: number
    size?: number
    tableId?: number
}): Promise<PageResponse<GameSession>> => {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('size', size.toString())
    if (tableId) {
        params.append('tableId', tableId.toString())
    }

    const response = await apiClient.get(`/sessions?${params.toString()}`)
    return response.data.data
}

export const addPlayerToSession = async (
    tableId: number,
    player: { userId?: number; guestName?: string }
): Promise<void> => {
    const response = await apiClient.post(`/tables/${tableId}/players`, player)
    return response.data.data
}

export const markPlayerLeft = async (
    tableId: number,
    assignmentId: number
): Promise<void> => {
    const response = await apiClient.post(`/tables/${tableId}/players/${assignmentId}/leave`)
    return response.data.data
}

export const finishSet = async (
    tableId: number,
    payerAssignmentIds: number[]
): Promise<void> => {
    const response = await apiClient.post(`/tables/${tableId}/finish-set`, {
        payerAssignmentIds
    })
    return response.data.data
}

export const updatePlayerAssignment = async (
    assignmentId: number,
    data: { playerName?: string; userId?: number }
): Promise<void> => {
    const response = await apiClient.put(`/players/${assignmentId}`, data)
    return response.data.data
}

export const confirmPlayerParticipation = async (
    assignmentId: number
): Promise<void> => {
    const response = await apiClient.post(`/players/${assignmentId}/confirm`)
    return response.data.data
}